import { IComponentOptions, IPromise } from "angular";

import "./brd-form.less";

export const BRD_FORM_COMPONENT :string = "brdForm";

class BrdFormComponentController {
    private onSubmit: () => IPromise<void>;
    private formInvalid: boolean;

    private wait: boolean;
    private error: string;

    private submit() {
        this.error = null;
        this.wait = true;

        this.onSubmit().then(
            null,
            messageError => {
                this.error = messageError || "An error occurred";
            })
            .finally(() => {
                this.wait = false;
            });
    }
}


export const brdFormComponentOptions: IComponentOptions = {
    transclude: {
        title: "brdFormTitle",
        inputs: "brdFormInputs"
    },
    bindings: {
        onSubmit: "&",
        formInvalid: "<"
    },
    controller: BrdFormComponentController,
    template: require("./brd-form.html")
};


// WEBPACK FOOTER //
// ./app/common/brd-form/brd-form.component.ts